import type { MonospacePolicyEntitlementResource } from '#layers/access/public';
import { RStoreSchema } from '#imports';
import { parseEntitlementResources } from '~/rstore/utils/parse-entitlement-resources';

export const WorkspaceEntitlementResource = RStoreSchema.withItemType<MonospacePolicyEntitlementResource>().defineCollection({
	name: 'WorkspaceEntitlementResource',
	getKey: (item) => item.name,
	meta: {
		useWorkspaceSlug: true,
		endpoint: 'entitlements',
		parse: { many: parseEntitlementResources },
	},
});
